<table
	mat-table
	class="list-container mb-3"
	[dataSource]="dataSource"
	matSort
	matSortDisableClear
>
	<ng-container matColumnDef="empty">
		<th
			mat-header-cell
			*matHeaderCellDef
			[colSpan]="resultColumns.length"
			class="text-center"
		>
			<div *ngIf="isLoading" class="list-loader">
				<mat-progress-bar mode="indeterminate"></mat-progress-bar>
			</div>
			<em> {{ listMessage }}</em>
		</th>
	</ng-container>
	<ng-container matColumnDef="createdBy">
		<th mat-header-cell *matHeaderCellDef>Note</th>
		<td mat-cell *matCellDef="let log">
			<div>
				<small class="created-by">{{ log.createdBy }}</small>
			</div>
		</td>
	</ng-container>
	<ng-container matColumnDef="description">
		<th mat-header-cell *matHeaderCellDef></th>
		<td mat-cell *matCellDef="let log">
			<div>
				<small fxFlex="100%">{{ log.description }}</small>
			</div>
		</td>
	</ng-container>
	<ng-container matColumnDef="created">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
		<td mat-cell *matCellDef="let log">
			<div>
				<small>{{ log.created | date: 'short' }}</small>
			</div>
		</td>
	</ng-container>
	<tr
		mat-header-row
		*matHeaderRowDef="resultColumns"
		[class.hidden]="listMessage"
	></tr>
	<tr
		mat-header-row
		*matHeaderRowDef="emptyColumns"
		[class.hidden]="!listMessage"
	></tr>
	<tr
		mat-row
		*matRowDef="let log; columns: resultColumns"
		[@animateList]
	></tr>
</table>

<div fxLayout [fxLayoutAlign]="paginatorLayoutAlign">
	<mat-paginator [pageSizeOptions]="[5, 10]" showFirstLastButtons></mat-paginator>
</div>
